import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html } from "lit";
import "../../atom/Row/index.js";
import { DsfStep } from "../Step/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfStepper = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "medium";
    this.dsf_direction = "horizontal";
  }
  update(changedProperties) {
    super.update(changedProperties);
    this.onSlotChange();
  }
  get slotOptionElements() {
    var _a, _b;
    return ((_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("#defaultSlot")) == null ? void 0 : _b.assignedElements().filter((elm) => elm instanceof DsfStep)) || [];
  }
  onSlotChange() {
    this.slotOptionElements.forEach((elm, index) => {
      elm.properties = {
        direction: this.dsf_direction,
        number: index + 1,
        size: this.dsf_size,
        isFirst: index === 0,
        isLast: index === this.slotOptionElements.length - 1
      };
    });
  }
  render() {
    if (this.dsf_direction === "vertical") {
      return html`
        <dsf-col dsf_justify="space-between" dsf_gap=${this.dsf_size === "minimal" ? "s" : "l"}>
          <slot id="defaultSlot" @slotchange=${this.onSlotChange}></slot>
        </dsf-col>
      `;
    }
    return html`
      <dsf-row dsf_gap="none">
        <slot id="defaultSlot" @slotchange=${this.onSlotChange}></slot>
      </dsf-row>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfStepper.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: String })
], DsfStepper.prototype, "dsf_direction", 2);
DsfStepper = __decorateClass([
  defineElement("dsf-stepper")
], DsfStepper);
export {
  DsfStepper
};
